import {
  GET_ORDERS_SUCCESS,
  UPDATE_ORDERS,
  UNUPDATE_ORDER,
  LOGOFF,
  CONCAT_ORDERS,
  INVALIDATE_USER
} from '../config/const';

const initialState = {
  orders: [],
  updated: false
};

const orderReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONCAT_ORDERS: {
      return {
        ...state,
        orders: [...state.orders, ...action.payload],
        currentPage: state.currentPage + 1
      };
    }

    case GET_ORDERS_SUCCESS: {
      let isUpdated = state.updated;

      const newOrders = action.payload.data;

      if (!Array.isArray(newOrders)) {
        return state;
      }

      const currentOrders = state.orders;

      let resultOrders = [];

      newOrders.forEach(newOrder => {
        const currentOrder = currentOrders.find((co) => co.orderId === newOrder.orderId);

        if (currentOrder) {
          newOrder.changed = currentOrder.changed;

          if (currentOrder.status !== newOrder.status) {
            isUpdated = true;
            newOrder.changed = true;
          }
        }

        resultOrders.push(newOrder);
      });

      return {
        ...state,
        updated: isUpdated,
        orders: resultOrders,
        totalPages: action.payload.totalPages,
        totalElements: action.payload.totalElements,
        currentPage: 0
      };
    }

    case UPDATE_ORDERS: {
      let isUpdated = false;

      const currentOrders = state.orders;
      const updatedOrder = action.payload.data;

      if (!Array.isArray(updatedOrder)) {
        return state;
      }

      const currentOrder = currentOrders.find((co) => co.orderId === updatedOrder[0].orderId);

      if (currentOrder) {
        currentOrder.changed = true;
        currentOrder.status = updatedOrder[0].status;
        currentOrder.lastUpdateAt = updatedOrder[0].lastUpdateAt;

        isUpdated = true;
      }

      return {
        ...state,
        updated: isUpdated,
        orders: [...currentOrders]
      };
    }

    case UNUPDATE_ORDER: {
      let isUpdated = false;
      
      const currentOrders = state.orders;
      const orderNumber = action.payload;

      const currentOrder = currentOrders.find((co) => co.orderNumber === orderNumber);

      if (currentOrder) {
        currentOrder.changed = false;

        isUpdated = true;
      }

      return {
        ...state,
        updated: isUpdated,
        orders: [...currentOrders]
      };
    }

    case INVALIDATE_USER:
    case LOGOFF:
      return initialState;

    default:
      return state;
  }
};

export default orderReducer;



// WEBPACK FOOTER //
// ./src/reducers/orderReducer.js